import React, { Component } from 'react'
import { ItemData } from '../apis/item.api'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import ContentAside from '../components/ContentAside'
import StockOnHandForm from '../partials/StockOnHandForm'
import ItemCard from '../components/ItemCard'

interface StockOnHandProps {}

interface StockOnHandState {
  item: ItemData | null
}

export default class StockOnHand
  extends Component<StockOnHandProps, StockOnHandState> {
  constructor (props: StockOnHandProps) {
    super(props)
    this.state = {
      item: null
    }
    this.handleItemChange = this.handleItemChange.bind(this)
  }

  get itemCard () {
    const { item } = this.state
    return item &&
      <ItemCard
        code={item.code}
        description={item.description}
        cpp={item.cpp}
        qpc={item.qpc}
        safetyStock={item.minimumStock} />
  }

  handleItemChange (item: ItemData | null) {
    this.setState({ item })
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="twoThird">
          <StockOnHandForm onItemSelect={this.handleItemChange} />
        </ContentMain>
        <ContentAside layout="oneThird">
          {this.itemCard}
        </ContentAside>
      </ContentLayout>
    )
  }
}
